<template>
  <div class="shopItem" @click="$parent.$parent.buyItem(name)">
    <p class="amount">{{ numfor(amount) }}</p>
    <p class="name">{{ displayName }}</p>
    <div class=" iBox">
      <p class="cost">cost: {{ numfor(cost) }}</p>
      <p class="cps">cps: {{ numfor(cps) }}</p>
    </div>
  </div>
</template>

<script>
import numfor from "../numfor";
export default {
  name: "Item",
  props: {
    name: String,
    displayName: String,
    amount: Number,
    cost: Number,
    cps: Number
  },
  data() {
    return { numfor };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shopItem {
  width: 100%;
  height: fit-content;
  background-color: #323232;
  color: white;
  display: block;
  position: relative;

  user-select: none;
  cursor: pointer;
}
.shopItem:not(:last-child) {
  margin-bottom: 2rem;
}
p {
  font-family: "Montserrat", sans-serif;
}
p.amount {
  position: absolute;
  display: inline-block;
  top: 0.1rem;
  left: 0.5rem;
  margin: 0px;
  font-size: 1.5rem;
}
p.name {
  text-align: center;
  font-size: 2rem;
  margin: 0px 0px;
}
p.cost,
p.cps {
  display: inline-block;
  padding: 0rem 1rem;
  font-size: 1.25rem;
}
.iBox {
  align-items: center;
  margin: auto;
  display: flex;
  justify-content: center;
}
</style>
